import styled from 'styled-components';
import moment from 'moment';

import DateInput from '../../../shared/DateInput';
import useDateInput from '../../../shared/DateInput/useDateInput';
import { Wrapper, Title } from '../../../shared/ModalComponents';
import { Button } from '../../../shared/FormStyles/Button';

const ButtonGroup = styled.div`
  padding: 8px 8px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const minDate = moment()
  .startOf('day')
  .toDate();

const SelectDates = ({ onCancel, initialDates, onSave, title, size = 1 }) => {
  const {
    activeFilter,
    startInputValue,
    endInputValue,
    dates,
    isValid,
    onDateChange,
    onInputChange,
    onFilterChange,
  } = useDateInput({ initialDates });
  const displayInputValue = `${startInputValue} - ${endInputValue}`;
  return (
    <Wrapper>
      <Title style={{ padding: '0 11px' }}>{title}</Title>
      <DateInput
        activeFilter={activeFilter}
        startInputValue={startInputValue}
        endInputValue={endInputValue}
        dates={dates}
        isValid={isValid}
        onDateChange={onDateChange}
        onInputChange={onInputChange}
        onFilterChange={onFilterChange}
        size={size}
        minDate={minDate}
      />
      <ButtonGroup>
        <Button variant="tertiary" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          variant="containedBlue"
          ml="8px"
          disabled={!(isValid && dates[1] >= minDate)}
          onClick={() => onSave(dates, displayInputValue)}
        >
          Save
        </Button>
      </ButtonGroup>
    </Wrapper>
  );
};

export default SelectDates;
